import { render, staticRenderFns } from "./news-nav.vue?vue&type=template&id=2124eb14&scoped=true"
import script from "./news-nav.vue?vue&type=script&lang=js"
export * from "./news-nav.vue?vue&type=script&lang=js"
import style0 from "./news-nav.vue?vue&type=style&index=0&id=2124eb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124eb14",
  null
  
)

export default component.exports